export const BACKGROUND_PORT = "background";
export const APP_PORT = "popup";
export const WEBPAGE_PORT = "webpage";
